import React, { useEffect, useCallback, useState} from 'react';
import {FM_PARAMETERS} from 'constants/pullable-types.js';
import PullablePart from "components/pulled/PullablePart.js";
import RackComponent from "components/effects/rack/RackComponent.js";
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';;

const MainFMParameters = ({isDraggable=true, setSelectedOscillator, instrument, color, osc, ...props}) => { 
    const [oscillator, setOscillator] = useState(
        osc === undefined ? instrument.oscillators[0] : osc);

    useEffect(() => {
        if (osc) {
            setOscillator(osc);
        }
    }, [osc, setOscillator]);

    let _oscillator = oscillator || instrument.oscillators[0];

    return (
        <PullablePart
          isDraggable={false}
          instrument={instrument}
          id={instrument.fmParameters.id}
          type={FM_PARAMETERS}
          className="instrument-section">
          <RackComponent
            color={color}
            track={props.track}
            scrollContainer={props.scrollContainer}
            setSelectedOscillator={(osc) => {
                if (!setSelectedOscillator) {
                    setOscillator(osc);
                } else {
                    setSelectedOscillator(
                        Math.max(0, instrument.oscillatorNodes.indexOf(osc)));
                }
            }}
            sequencerEngine={props.sequencerEngine}
            effect={instrument}/>
          <div
            className="fm-parameters">
            <div className="osc-name">{_oscillator.name}</div>
            <div className="fm-parameters-container">
                <EffectParameterSlider
                  automation={props.automation}
                  name={'Harmonicity'}
                  sequencerEngine={props.sequencerEngine}
                  lfoEnabled={true}
                  parameter={_oscillator.harmonicityParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={20}
                  step={0.01}
                />
                <EffectParameterSlider
                  automation={props.automation}
                  name={'Modulation'}
                  sequencerEngine={props.sequencerEngine}
                  parameter={_oscillator.modulationIndexParameter}
                  lfoEnabled={true}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={125}
                  step={0.01}
                />
              </div>
            </div>
        </PullablePart>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainFMParameters);
